'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Loader2 } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

interface QueueSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showCount?: boolean;
  count?: number;
  color?: string;
}

export function QueueSpinner({
  size = 'md',
  className = '',
  showCount = false,
  count = 0,
  color = 'text-primary',
}: QueueSpinnerProps) {
  const t = useTranslations('common');
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  const textSizeClasses = {
    sm: 'text-progress-meta',
    md: 'text-list-item-subtitle',
    lg: 'text-card-body',
  };

  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center',
        className
      )}
    >
      <Loader2
        className={cn(sizeClasses[size], 'animate-spin', color)}
        role="status"
        aria-label={t('processingQueue')}
      />

      {/* Count in center if enabled */}
      {showCount && count > 0 && (
        <div
          className={cn(
            'absolute inset-0 flex items-center justify-center font-semibold',
            textSizeClasses[size]
          )}
        >
          {count}
        </div>
      )}
    </div>
  );
}
